/**
 * 询价单货好时间（CRD）展示工具，供 custom-quotation-v2 下各 detail 页复用。
 * - cargoReadyTimeType=date：展示 cargoReadyTimeDate 具体日期（yyyy-MM-dd）。
 * - cargoReadyTimeType=range：展示 cargoReadyTimeStart ~ cargoReadyTimeEnd 日期区间（yyyy-MM-dd）。
 */
export const formatCargoReadyTime = (record?: Record<string, any> | null): string => {
  if (!record) return '-'
  if (record.cargoReadyTimeType === 'date' && record.cargoReadyTimeDate) {
    return String(record.cargoReadyTimeDate).slice(0, 10)
  }
  if (record.cargoReadyTimeType === 'range') {
    const start = record.cargoReadyTimeStart ? String(record.cargoReadyTimeStart).slice(0, 10) : ''
    const end = record.cargoReadyTimeEnd ? String(record.cargoReadyTimeEnd).slice(0, 10) : ''
    const range = [start, end].filter(Boolean).join(' ~ ')
    if (range) return range
  }
  return '-'
}
